<template>
  <div class="ops-message">
    <h1>未授权用户</h1>
    <h2>您不具备访问此页面的权限，请联系相关产品管理员进行授权操作，或尝试
      <b-button size="sm" type="text" icon="el-icon-refresh" @click="hhHome.updatePermission()">更新权限</b-button>
    </h2>
    <div>
      <b-button size="sm" type="primary" @click="goPage('/')">返回首页</b-button>
      <b-button size="sm" type="primary" @click="backPage()">返回上一页</b-button>
    </div>
  </div>
</template>
<script>
  export default {
    inject: ['hhHome']
  }
</script>
